<!--管理员列表-->
<template>
    <div >
                <!--<el-button type="primary" @click="debug(-1)"-->
                           <!--size="mini">debug-->
                <!--</el-button>-->
        <!--[[[{{inputType}}-->
        <!--<span v-for="item in selectItems"-->
                   <!--:label="item.title"-->
                   <!--:value="parseInt(item.id)" :key="item.id">-->
            <!--&lt;!&ndash;_{{parseInt(item.id)}}_&ndash;&gt;-->
        <!--</span>-->
        <!--={{fieldValueSrc}}=-->
        <!--{{requiredCurrent}}]]-->
        <!--{{fieldValueSrc}}]]]]]]-->

        <!--{{fieldValueSrc}}-->
        <!--{{requiredCurrent}}-->
        <el-radio-group v-model="fieldValueSrc" v-if="inputTypeCurrent=='select'&& selectItems.length<=3&&!isQuery"  @change="changeSelect"
        :disabled="disabled">
            <el-radio v-if="!requiredCurrent" label="" >请选择</el-radio>
            <!--<el-radio label="" >请选择</el-radio>-->
            <el-radio  v-for="item in selectItems"
                       :label="item.id"
                        :key="item.id" >{{item.title}}</el-radio>
        </el-radio-group>




        <el-select
                @change="changeSelect"
                :disabled="disabled"
                v-model="fieldValueSrc"
                filterable
                reserve-keyword
                placeholder="请输入关键词"
            v-if="(inputTypeCurrent=='select'&& selectItems.length>3)||isQuery"
        >
            <el-option
                    :label="defaultLabelStr"
                    value=""
                    >

            </el-option>
            <el-option v-for="item in selectItems"
                    :label="item.title"
                    :value="parseInt(item.id)" :key="item.id">
            </el-option>
            <!--<el-option-->
                    <!--label="非主库"-->
                    <!--:value="0">-->
            <!--</el-option>-->
        </el-select>

        <el-checkbox-group
                :disabled="disabled"
                v-model="fieldValueSrc" v-if="inputTypeCurrent&&inputTypeCurrent=='checkbox'"  @change="changeSelect">
            <el-checkbox v-for="item in selectItems"  :label="item.id" :key="(item.id)">{{item.title}}</el-checkbox>
            <!--<el-checkbox label="复选框 B"></el-checkbox>-->
            <!--<el-checkbox label="复选框 C"></el-checkbox>-->
            <!--<el-checkbox label="禁用" disabled></el-checkbox>-->
            <!--<el-checkbox label="选中且禁用" disabled></el-checkbox>-->
        </el-checkbox-group>
    </div>
</template>

<script>
    import formuiService from '../service/formui/FormuiService.js'
    import moment from 'moment'
//订单类型
    export default {
        name: 'OrderIsMainSelect',
        props: ['beanName','fieldName','fieldValue','defaultLabel','inputType','required','isQuery','disabled'],
        methods: {
            clickRadio:function(){

//                alert('radio')
            },
            debug:function(){
//                if(!this.fieldValueSrc){
//                    this.fieldValueSrc=0
//                }
//                this.fieldValueSrc=parseInt(this.fieldValueSrc)+1
////                this.fieldValueSrc='123'
                this.fieldValueSrc=1
                this.changeSelect();
            },
            changeSelect:function () {
//              alert(22)
//                let tmp=this.fieldValueSrc;
////                this.debug()
//                this.fieldValueSrc=tmp
//                console.log(this.fieldValueSrcs)
//                alert(this.fieldValueSrcs)
//                if(this.fieldValueSrcs){
//                    this.$emit('setFieldValue', this.fieldName, this.fieldValueSrcs.toString())
//                }else{
//                    alert(parseFloat(this.fieldValueSrc).toString())
                if (this.inputTypeCurrent!=='checkbox') {
//                    alert(this.fieldName+'______'+this.fieldValueSrc)
                    if(this.fieldValueSrc===''){
//                        alert(1)
                        this.$emit('setFieldValue', this.fieldName,'')
                        return
                    }
                    this.$emit('setFieldValue', this.fieldName,parseInt(this.fieldValueSrc))
                }else{

                    this.$emit('setFieldValue', this.fieldName, this.fieldValueSrc.toString())
                }

//                }

            },

        },

        data () {
            return {
                requiredCurrent:false,
                inputTypeCurrent:'select',
              defaultLabelStr:'请选择',
                selectItems:[],
                fieldValueSrc:''

            }
        },
        mounted () {
            let that = this

            if(this.required===true||this.required===false){
                this.requiredCurrent=this.required
            }
//            alert(that.beanName)
            formuiService.getFormuiStyle(that,{beanName:that.beanName},function (resp) {
                that.selectItems=resp.selectItems

//                this.selectItems.length

                if(that.requiredCurrent){
//                    alert(that.fieldName+'-----'+that.fieldValueSrc)
                    if(that.fieldValueSrc===null||that.fieldValueSrc===''){

                        that.fieldValueSrc=parseInt(that.selectItems[0].id)
                        that.changeSelect()
//                        alert(that.requiredCurrent+'__'+that.fieldName+'______'+that.fieldValueSrc)
                    }
                }
            })
//            alert(that.requiredCurrent+'::'+that.fieldName+'______'+that.fieldValueSrc)
//            alert(this.fieldValue)


            if(this.fieldValue||this.fieldValue===0){
//                alert(this.fieldValue)
                this.fieldValueSrc=parseInt(this.fieldValue)
            }

            if(this.defaultLabel){
                this.defaultLabelStr=this.defaultLabel
            }


            if(this.inputType){
                this.inputTypeCurrent=this.inputType

                if(this.inputType=='checkbox'){
                    this.fieldValueSrc=[]
                }else{
//                    alert(1)
//                    alert(this.selectItems.length)
//                    alert(this.selectItems[0].id)
//                    this.fieldValueSrc=this.selectItems[0].id
                    if(this.fieldValueSrc===null||this.fieldValueSrc===''){
                        if(this.requiredCurrent){
                            this.fieldValueSrc=null
                        }

                    }

                }
            }

            this.changeSelect()
//            if(!this.fieldValueSrc){
//                this.fieldValueSrc=0
//                this.changeSelect();
//            }
        },


    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// node_modules/formui-vue2-vistastory/widget/FormUiStyleSelect.vue